// Sekmeli kabukta ana eylemi başlığın sağ üstüne taşır.
//
// Başlık kabuktadır, eylem ise çocuk paneldedir: düğme o panelin yerel
// durumunu (kipin açık olması, yetki, mutasyon) okur. Eylemi kabuğa bir
// rota→eylem haritası olarak yazmak düğmeyi durumundan koparırdı; bu yüzden
// panel düğmeyi kendi ağacında tutar ve yalnız DOM'da başlığın eylem yuvasına
// portal ile çizilir.

import { createContext, useContext, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

// `undefined` = kabuk yok; `null` = kabuk var ama yuva henüz bağlanmadı.
const TargetContext = createContext<HTMLElement | null | undefined>(undefined);

export interface PageHeaderActionsHost {
  /** Kabuğun PageHeader `actions` prop'una verilir. */
  readonly slot: ReactNode;
  /** Eylem taşıyan çocukları saran `PageHeaderActionsProvider`'a verilir. */
  readonly target: HTMLElement | null;
}

export function usePageHeaderActionsHost(): PageHeaderActionsHost {
  const [target, setTarget] = useState<HTMLElement | null>(null);
  return { slot: <span ref={setTarget} className="contents" />, target };
}

export function PageHeaderActionsProvider({
  target,
  children,
}: {
  readonly target: HTMLElement | null;
  readonly children: ReactNode;
}): React.ReactElement {
  return <TargetContext.Provider value={target}>{children}</TargetContext.Provider>;
}

export function PageHeaderActions({ children }: { readonly children: ReactNode }): ReactNode {
  const target = useContext(TargetContext);
  // Kabuksuz çizimde (tek başına panel) düğme kaybolmasın diye yerinde kalır.
  if (target === undefined) return children;
  if (target === null) return null;
  return createPortal(children, target);
}
